export default __webpack_public_path__ + "static/media/The Complicated Questions.331a0ca2.jpg";